<script>
    import {onMount} from "svelte";
    import {customFetch} from "../customFetch";
    import {gameBuildsUrl, gameBuildUrl} from "../urls";
    import Transition from "../components/Transition.svelte";

    onMount(init);

    let rows = [];
    async function init() {
        let response = await customFetch(gameBuildsUrl());
        rows = await response.json();
    }
</script>
<Transition>
    <div class="content-container">
        <table class="table">
            <thead><tr>
                <th>Number</th>
                <th>Platform</th>
                <th>Defines</th>
                <th>Link</th>
            </tr></thead>
            <tbody>
            {#each rows as row}
                <tr>
                    <td class="w-fit">{row.BuildNumber}</td>
                    <td class="w-fit">{row.Platform}</td>
                    <td class="w-fit">{row.Defines}</td>
                    <td class="w-fit"><a href="{gameBuildUrl(row.UUID)}">Download</a></td>
                </tr>
            {/each}
            </tbody>
        </table>
    </div>
</Transition>

<style>
    th,
    td {
        padding: 0.5rem;
        border: 1px solid #ddd;
    }
</style>